import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group cursor-pointer">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative overflow-hidden rounded-lg mb-4 aspect-[16/10]">
          <img
            src={article.imageUrl}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-3 left-3">
            <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              {article.category}
            </span>
          </div>
          <div className="absolute top-3 right-3 flex items-center gap-1 bg-foreground-950/70 backdrop-blur-sm text-accent-400 px-2 py-1 rounded-full">
            <i className="ri-star-fill text-xs"></i>
            <span className="text-xs font-semibold">{article.rating}</span>
          </div>
        </div>

        <h3 className="font-heading text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
          {article.title}
        </h3>

        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {article.excerpt}
        </p>

        <div className="flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-user-line"></i>
            {article.director}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-calendar-line"></i>
            {article.year}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-time-line"></i>
            {article.runtime}
          </span>
        </div>
      </Link>
    </article>
  );
}